import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

interface NewConversationIconProps {
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  strokeColor?: string;
  width?: number;
  height?: number;
  className?: string;
}

const NewConversationIcon: React.FC<NewConversationIconProps> = ({
  primaryColor,
  secondaryColor,
  accentColor,
  strokeColor,
  width = 30,
  height = 30,
  className,
}) => {
  const { token } = useToken();
  const primary = primaryColor ?? '#185A77';
  const secondary = secondaryColor ?? '#D9D9D9';
  const accent = accentColor ?? token.colorPrimary;
  const stroke = strokeColor ?? '#223348';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.5312 3.75C11.6728 3.75314 8.93242 4.89003 6.91122 6.91122C4.89003 8.93242 3.75314 11.6728 3.75 14.5312V23.5875C3.75 24.045 3.93174 24.4838 4.25524 24.8073C4.57874 25.1308 5.0175 25.3125 5.475 25.3125H14.5312C17.3906 25.3125 20.1329 24.1766 22.1547 22.1547C24.1766 20.1329 25.3125 17.3906 25.3125 14.5312C25.3125 11.6719 24.1766 8.92963 22.1547 6.90775C20.1329 4.88588 17.3906 3.75 14.5312 3.75ZM14.5312 23.5875H5.475V14.5312C5.475 12.7401 6.00614 10.9892 7.00125 9.49987C7.99637 8.01057 9.41076 6.84981 11.0656 6.16437C12.7204 5.47892 14.5413 5.29958 16.298 5.64901C18.0548 5.99845 19.6684 6.86097 20.935 8.12751C22.2015 9.39405 23.064 11.0077 23.4135 12.7645C23.7629 14.5212 23.5836 16.3421 22.8981 17.9969C22.2127 19.6517 21.0519 21.0661 19.5626 22.0612C18.0733 23.0564 16.3224 23.5875 14.5312 23.5875Z"
        fill={primary}
      />
      <path
        d="M25.6484 9.89647C23.4308 9.89647 21.2131 7.6788 21.2131 5.46112C21.2131 7.6788 18.9954 9.89647 16.7777 9.89647C18.9954 9.89647 21.2131 12.1142 21.2131 14.3318C21.2131 12.1142 23.4308 9.89647 25.6484 9.89647Z"
        fill={secondary}
        stroke={stroke}
        strokeWidth="6.44868"
        strokeLinejoin="round"
      />
      <path
        d="M25.6504 9.58129C23.5904 9.58129 21.5304 7.5213 21.5304 5.4613C21.5304 7.5213 19.4704 9.58129 17.4104 9.58129C19.4704 9.58129 21.5304 11.6413 21.5304 13.7013C21.5304 11.6413 23.5904 9.58129 25.6504 9.58129Z"
        fill={accent}
        stroke={accent}
        strokeWidth="0.71652"
        strokeLinejoin="round"
      />
      <path
        d="M11.9425 10.836C12.4369 10.836 12.8382 10.435 12.8382 9.94033C12.8382 9.44569 12.4369 9.04468 11.9425 9.04468C11.4481 9.04468 11.0469 9.44569 11.0469 9.94033C11.0469 10.435 11.4481 10.836 11.9425 10.836Z"
        fill={accent}
      />
      <path
        d="M16.3156 14.7894L15.1793 14.4084L14.7998 13.2627C14.6772 12.8926 14.0682 12.8926 13.9457 13.2627L13.5661 14.4084L12.4298 14.7894C12.246 14.8511 12.1211 15.0241 12.1211 15.2201C12.1211 15.4161 12.246 15.5891 12.4298 15.6508L13.5661 16.0318L13.9457 17.1774C14.007 17.3625 14.1788 17.4871 14.3721 17.4871C14.5655 17.4871 14.7385 17.3613 14.7986 17.1774L15.1781 16.0318L16.3144 15.6508C16.4982 15.5891 16.6231 15.4161 16.6231 15.2201C16.6231 15.0241 16.4982 14.8511 16.3144 14.7894H16.3156Z"
        fill={accent}
      />
    </svg>
  );
};

export default NewConversationIcon;
